<template>
 <!-- :style="{'min-height': docHt + 'px'}" -->
  <div class="wrapper">
    <div class="container">
      <div class="section ql-editor" v-html="dataInfo"></div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="submit-btn disabled-btn" v-if="count > 0">我已阅读，并同意签约该协议{{seconds}}s</div>
      <div class="submit-btn" @click="toJump" v-else>我已阅读，并同意签约该协议</div>
      <!-- <router-link :to="'/payment'" class="submit-btn" v-else>我已阅读，并同意签约该协议</router-link> -->
    </div>
  </div>
</template>


<script>
import { getAnnualFeeInfo, examineConfirmed, contract } from '@/api/baseinfo';
export default {
  name: 'agreement',
  data () {
    return {
      shopCode: undefined,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      seconds: '06',
      count: 6,
      timer: null,
      form: {},
      dataInfo:''
    }
  },
  created() {
    this.shopCode = this.$route.query && this.$route.query.shopCode ? this.$route.query.shopCode : undefined;
    this.form.annualFee = sessionStorage.getItem('annualFee');
    this.getInfo();
    this.getCount();
  },
  methods: {
    getInfo(){
      contract('CS20220613110377').then(res => {
        if(res.data.articleJson){
          let data = res.data;
          let articleJson = JSON.parse(data.articleJson);
          this.dataInfo = articleJson.AT;
        }
      })
    },
    getCount(){
      const TIME_COUNT = 6;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.seconds = this.count < 10 ? '0'+this.count : this.count;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }
    },
    toJump() {
      examineConfirmed(this.shopCode).then(res => {
        if(res.code == 200) {
          getAnnualFeeInfo(this.shopCode).then(res => {
            if(!res.data) return false;
            if(res.data.setMealMoney === 0 || res.data.isPay == 1) {
              this.$router.push({
                path: '/baseinfo-auth?shopCode=' + this.shopCode
              })
            } else if(res.data.isPay == 0) {
              this.$router.push({
                path: '/payment?shopCode=' + this.shopCode
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding: .75rem 0;
    position: relative;
    h3{
      font-size: 1.2rem;
      color: #222;
      text-align: center;
      margin: .8rem 0 1.4rem;
    }
  }
  .section{
    line-height: 1.5;
    width: 15.6rem;
    margin: 0 auto;
    padding-bottom: 5rem;
    >>> p{
      line-height: 1.5;
      font-size: .7rem;
      color: #222;
      text-align: left;
      margin-bottom: 1.25rem;
    }
    >>> span{
      line-height: 1.5;
      display: inline-block;
    }
  }
}
@media screen and (min-width:750px){
  .wrapper{
    height: auto !important;
  }
  .container{
    height: 70vh;
    padding: 15px 0;
    position: relative;
    h3{
      font-size: 24px;
      color: #222;
      text-align: center;
      margin: 16px 0 28px;
    }
  }
  .section{
    line-height: 1.5;
    width: 312px;
    margin: 0 auto;
    padding-bottom: 80px;
    >>> p{
      line-height: 1.5;
      font-size: 14px;
      color: #222;
      text-align: left;
      margin-bottom: 25px;
    }
    >>> span{
      line-height: 1.5;
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agreement.vue